import { useNavigate, useParams } from 'react-router-dom-v6'
import { Skeleton } from '@clouway/ui'

import { ConfigTemplateWizard } from '../components/ConfigTemplateWizard'
import { useConfigTemplates, useUpdateConfigTemplate } from '../hooks'
import { formValuesToTemplate, templateToFormValues } from '../transforms'
import type { ConfigTemplate, ConfigTemplateFormValues } from '../types'

export function EditConfigTemplate() {
  const { id = '' } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { data: templates, isLoading } = useConfigTemplates()
  const { mutateAsync: update } = useUpdateConfigTemplate()

  // === comparison (the mobile used `t.id = id`, an assignment that mutated
  // every template and returned the first).
  const template = templates?.find((t) => t.id === id)

  const onSubmit = async (values: ConfigTemplateFormValues) => {
    await update({ ...formValuesToTemplate(values), id, cid: template?.cid ?? '' } as ConfigTemplate)
    navigate('/config-templates')
  }

  if (isLoading || !template) return <Skeleton className="mx-auto h-96 w-full max-w-2xl" />

  return <ConfigTemplateWizard initialValues={templateToFormValues(template)} onSubmit={onSubmit} />
}
